// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "a475b6c59b3c68cbd03aecc96e91de7863f40d8e/static/css/" + chunkId + "." + {"252":"3d0d1673","725":"84c1fc5e","854":"36854e5e"}[chunkId] + ".chunk.css";
};